import NiceModal, { useModal } from '@ebay/nice-modal-react'
import ScrollLockModal from 'shared/ScrollLockModal'
import React from 'react'
import { ReturnInstructionsModalProps } from './ReturnInstructionsModal.types'
import css from './ReturnInstructionsModal.styles.scss'
import ReturnContactInfo from './components/ReturnContactInfo/ReturnContactInfo'
import Chat from './components/Chat/Chat'

const Separator: React.FC = () => (
  <div className={css.ReturnInstructionsModal__Separator} />
)

const ReturnInstructionsModal = NiceModal.create(
  ({ reservation }: ReturnInstructionsModalProps) => {
    const modal = useModal()

    const handleChat = async () => {
      window.zE('webWidget', 'open')
      window.zE('webWidget', 'show')
      await modal.hide()
    }

    return (
      <ScrollLockModal
        showCloseButton
        handleClose={modal.hide}
        handleDismount={modal.remove}
        isOpen={modal.visible}
        title="Return information"
      >
        <div className={css.ReturnInstructionsModal__ContentContainer}>
          <ReturnContactInfo reservation={reservation} />
          <Separator />
          <Chat onChat={handleChat} />
        </div>
      </ScrollLockModal>
    )
  }
)

export default ReturnInstructionsModal
